<template>
	<div class="item-row-group">
		<hr v-if="answerInputidx > 0"/>
		<div class="item-row">
			<div class="left display-flex align-items-center" v-html="infoHtml"></div>
			<div class="right">
				<button class="button button-fill" :disabled="mode != 'ANSWER'" v-on:click="editEquationBtnClick"><i class="f7-icons">function</i></button>
			</div>
		</div>
		<div class="item-row item-input-outline" style="margin-top:4px">
			<div class="eq-editor item-cell" ref="eqEditor" v-on:update="editChanged" @input="editChanged" :contenteditable="mode == 'ANSWER'" placeholder="정답 입력"></div>
			<div class="eq-block item-cell" style="width:60px" v-html="unitHtml"></div>
		</div>
		<div v-if="mode == 'SCORE'">
			<span class="text-color-purple">정답 : </span><br/>
			<span v-for="(answer, i) in answerList" :key="'i' + i" style="margin:0;">
				<span v-html="convertEquation(answer)"></span>
				<span v-if="i < answerList.length-1"> 이거나, <br/></span>
				<span v-else>이면 정답.</span>
			</span>
		</div>
	</div>
</template>


<script>
import MODULE from '../../js/common/module';
import store from '../../js/store';
import MathLive from 'mathlive';

export default {
	props: {
		examNo: { default: 0 },
		subExamIdx: { default: 0 },
		answerInputidx: { default: 0 },
	},
	data() {
		return {
			infoHtml: "",
			unitHtml: "",
		}
	},
	computed: {
		mode() {
			var mode = this.getCommonObj().mode;
			return mode;
		},
		info() {
			return this.getAnswerInput().info;
		},
		unit() {
			return this.getAnswerInput().unit;
		},
		answerList() {
			return this.getAnswerInput().answerList;
		},
		inputAnswer: {
			get() {
				return this.getAnswerInput().inputAnswer;
			},
			set(newValue) {
				var answerInput = this.getAnswerInput();
				answerInput.inputAnswer = newValue;
			}
		}
	},
	mounted() {
		this.renderInfo();
		this.renderUnit();
		this.renderInputAnswer();
	},
	methods: {
		getCommonObj() {
			return store.getters.commonObj;
		},
		getAnswerInput() {
			var answers = this.getCommonObj().answers;

			var examIndex = this.examNo - 1;
			var exam = answers[examIndex];
			var subExam = exam.subExamList[this.subExamIdx];
			var answerInput = subExam.answerInputList[this.answerInputidx];

			return answerInput;
		},
		convertToEquationDisplay(div) {
			var _this = this;

			var html = div.html();

			var eqReplacer = function (match) {
				var subHtml = match;
				var subDiv = $("<div>" + subHtml + "</div>");
				MathLive.renderMathInElement(subDiv[0]);

				return subDiv.html();
			}

			html = html.replace(/\$\$.+\$\$/g, eqReplacer);

			div.html(html);

			div.find("span.sr-only").remove();

			div.find(".ML__mathlive").prop("contenteditable", false);

			div.find(".ML__mathlive").css({
				"border": "1px solid #ccc",
				"padding": "4px 2px 2px 2px",
				"margin": "2px 2px",
				"font-size": "1.8rem",
				"font-size": "18px",
				"user-select": "none",
				"vertical-align": "middle"
			});
		},
		convertToEquationEditor(div) {
			var _this = this;

			var html = div.html();

			var eqReplacer = function (match) {
				var subHtml = match;
				var subDiv = $("<div>" + subHtml + "</div>");
				MathLive.renderMathInElement(subDiv[0]);

				return subDiv.html();
			}

			html = html.replace(/\$\$.+\$\$/g, eqReplacer);

			div.html(html);

			div.find("span.sr-only").remove();

			div.find(".ML__mathlive").prop("contenteditable", false);
			div.find(".ML__mathlive").ev("mousedown", function (e) {
				var element = $(this);

				var editorGroup = element.closest("div.eq-editor");
				var eqRootSpan = element.closest("span[data-original-content]");
				_this.editEquation(editorGroup, eqRootSpan);
			});

			div.find(".ML__mathlive").css({
				"border": "1px solid #ccc",
				"padding": "4px 2px 2px 2px",
				"margin": "2px 2px",
				"font-size": "1.8rem",
				"font-size": "18px",
				"cursor": "pointer",
				"user-select": "none",
				"vertical-align": "middle"
			});
		},
		renderInfo() {
			let html = this.info;
			if (MODULE.Util.isEmpty(html)) {
				this.infoHtml = "주관식형 답안"
			} else {
				this.infoHtml = MODULE.UITool.convertEquationHTML(html);
			}
		},
		renderUnit() {
			let html = this.unit;
			this.unitHtml = MODULE.UITool.convertEquationHTML(html);
		},
		renderInputAnswer() {
			var _this = this;

			var _editor = _this.$refs.eqEditor;
			var editor = $(_editor);
			editor.html(this.inputAnswer);
			_this.convertToEquationEditor(editor);
		},
		convertEquation(equation) {
			let html = equation;
			return MODULE.UITool.convertEquationHTML(html);
		},
		editChanged(e) {
			// const editor = $(e.currentTarget);
			
			var _this = this;
			
			var _editor = _this.$refs.eqEditor;
			var editor = $(_editor);
			const answer = MODULE.UITool.recursiveGetTextContents(editor[0]);

			this.inputAnswer = answer;
		},
		editEquationBtnClick(e) {
			const element = $(e.currentTarget);
			const itemRowGroup = element.closest(".item-row-group");
			const editor = itemRowGroup.find("div.eq-editor");

			this.editEquation(editor, undefined);
		},
		openEquationDialog(equation) {
			var def = jQuery.Deferred();

			const eqDialog = $("#equation-popup");
			eqDialog.off("popup:closed").on("popup:closed", function(e) {
				var equation = eqDialog.data("equation");
				
				def.resolve(equation);
			});

			eqDialog.data("equation", equation);

			this.$f7.popup.open("#equation-popup", true);

			return def.promise();
		},
		editEquation: function(editor, eqRootSpan) {
			var _this = this;

			if (_this.mode != 'ANSWER') {
				return;
			}

			// mousedown후 바로 editor.focus 불가능
			// 비동기로 다음 이벤트로 넘겨야 focus가 정상 작동함.
			MODULE.UITool.asyncRun(function () {
				editor.focus();
				MODULE.UITool.saveCaretPosition(editor);
			}).then(function (data) {
				var equation = " ";	// must space. NOT empty("") !!
				if (eqRootSpan != undefined) {
					equation = eqRootSpan.data("original-content");
				}

				return _this.openEquationDialog(equation);
			}).then(function (data) {
				if (data != undefined && data != "") {
					var equation = data;
					var html = "<div>$$" + equation + "$$</div>";
					
					var div = $(html);
					_this.convertToEquationEditor(div);

					editor.focus();
					MODULE.UITool.restoreCaretPosition(editor);

					if (eqRootSpan != undefined) {
						var jqueryElement = div.find("span[data-original-content]");

						eqRootSpan.replaceWith(jqueryElement);
					} else {
						/*
						var element = $("<span>&zwnj;</span>");
						element = element[0];
						_this.insertElementAtCaret(element);
						*/

						var element = div.find("span[data-original-content]");
						element = element[0];
						_this.insertElementAtCaret(element);

						/*
						var element = $("<span>&zwnj;</span>");
						element = element[0];
						_this.insertElementAtCaret(element);
						*/
					}

					var html = editor.html();
					editor.data("before", html);
					editor.trigger("change");
					editor.trigger("special-change");
					_this.editChanged();	// change 발생하지 않아서 직접 호출

					MODULE.UITool.asyncRun(function () {
						editor.focus();
					});
				} else {
					editor.focus();
					MODULE.UITool.restoreCaretPosition(editor);

					editor.trigger("change");
					editor.trigger("special-change");
					_this.editChanged();	// change 발생하지 않아서 직접 호출
				}
			}).catch(function (code) {
				editor.focus();
				MODULE.UITool.restoreCaretPosition(editor);
			});
		},
		insertElementAtCaret: function (element) {
			var _this = this;

			var sel, range;
			if (window.getSelection) {
				// IE9 and non-IE
				sel = window.getSelection();
				if (sel.getRangeAt && sel.rangeCount) {
					range = sel.getRangeAt(0);
					range.deleteContents();
					range.insertNode(element);

					range.setStartAfter(element);
					range.setEndAfter(element);
					range.collapse(true);

					sel.removeAllRanges();
					sel.addRange(range);
				}
			} else if ((sel = window.selection) && sel.type != "Control") {
				// IE < 9
				var originalRange = sel.createRange();
				originalRange.collapse(true);
				sel.createRange().pasteHTML(html);
			}
		},

	}
}
</script>